interface RangeSelectorProps {
  value: number;
  onChange: (days: number) => void;
}

const OPTIONS: Array<{ days: number; label: string }> = [
  { days: 7, label: "7d" },
  { days: 30, label: "30d" },
  { days: 90, label: "90d" },
  { days: 365, label: "1y" },
];

/**
 * Shared range-in-days picker used on Dashboard / Analytics / Credits /
 * Funnel pages. Backed by useRange so the choice persists across reloads.
 */
export function RangeSelector({ value, onChange }: RangeSelectorProps) {
  return (
    <div className="range-selector">
      {OPTIONS.map((opt) => (
        <button
          key={opt.days}
          type="button"
          className={`range-btn ${value === opt.days ? "active" : ""}`}
          onClick={() => onChange(opt.days)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
